import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Chatbot from './Chatbot/Chatbot';
import { trackPageView } from '../utils/analytics';

const Layout = ({ user, setUser }) => {
  const location = useLocation();
  const isLanding = location.pathname === '/';

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    trackPageView(`${location.pathname}${location.search}`, {
      category: params.get("category") || undefined
    });
  }, [location.pathname, location.search]);

  return (
    <div className="layout-container">
      {!isLanding && <Navbar user={user} setUser={setUser} />}
      <main className="main-content">
        <Outlet />
      </main>
      {!isLanding && <Chatbot />}
      {!isLanding && <Footer />}
    </div>
  );
};

export default Layout;
